<template lang="pug">
div
  .md-headline Social Media Share URL's
  md-list()
    md-list-item.list(v-for='(shareUrl, i) in shareUrls' :key='i')
      md-input-container
        md-icon(:md-iconset='socialMediaNameMap[shareUrl.type].icon')
        label {{ socialMediaNameMap[shareUrl.type].name || '' }} share URL
        md-input(v-model='shareUrls[i].url', type='text')
        md-button#btn-delete(@click='clearInput(i)') X
</template>

<script>
  export default {
    data() {
      return {
        socialMediaNameMap: {
          facebookShare: {name: 'Facebook', icon: 'fab fa-facebook'},
          instagramShare: {name: 'Instagram', icon: 'fab fa-instagram'},
        }
      }
    },
    props: {
      shareUrls: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    methods: {
      clearInput(index) {
        this.$emit('clear-input', index);
      }
    }
  };
</script>

<style lang="scss" scoped>
.text-list {
  max-width: 500px;
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon {
  margin: auto !important;
}
#btn-delete {
  color: rgb(255, 0, 0);

  &:hover {
    transform: scale(1.2);
    color: rgb(255, 0, 0) !important;
    background-color: transparent !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/SnsShareForm.vue